import { HttpClient } from 'api/http-client';
import { APIKeyUrl } from './constants';
import { ApiKey, CreateApiKeyPayload } from './types';

class APIKeyHTTPClient extends HttpClient {
  public getZapierKey = (): Promise<ApiKey> =>
    this.get<ApiKey>(APIKeyUrl.getZapierKey);

  public createZapierKey = (payload: CreateApiKeyPayload): Promise<ApiKey> =>
    this.post<ApiKey, CreateApiKeyPayload>(APIKeyUrl.createZapierKey, payload);

  public getWorkatoKey = (): Promise<ApiKey> =>
    this.get<ApiKey>(APIKeyUrl.getWorkatoKey);

  public createWorkatoKey = (payload: CreateApiKeyPayload): Promise<ApiKey> =>
    this.post<ApiKey, CreateApiKeyPayload>(APIKeyUrl.createWorkatoKey, payload);

  public getRLApiKey = (): Promise<ApiKey[]> =>
    this.get<ApiKey[]>(APIKeyUrl.getRLApiKey, {
      params: { loginType: 'USER' },
    });

  public createRLApiKey = (payload: CreateApiKeyPayload): Promise<ApiKey> =>
    this.post<ApiKey, CreateApiKeyPayload>(APIKeyUrl.createRLApiKey, payload);

  public deleteRLApiKey = (id: number): Promise<void> =>
    this.delete<void>(APIKeyUrl.deleteRLApiKey(id));

  public getJWTForAPIKey = (apiKeyId: string): Promise<string> =>
    this.get<string>(APIKeyUrl.getJWTForAPIKey(apiKeyId));

  public getHubspotKey = (): Promise<ApiKey> =>
    this.get<ApiKey>(APIKeyUrl.getHubspotKey);

  public createHubspotKey = (payload: CreateApiKeyPayload): Promise<ApiKey> =>
    this.post<ApiKey, CreateApiKeyPayload>(APIKeyUrl.createHubspotKey, payload);
}

export const APIKeysApi = new APIKeyHTTPClient();
